import { systemNames } from 'wikr-core-analytics';

export const excludeAnalyticsSystems = (systems: string[]) =>
    Object.values(systemNames).filter((el) => !systems.includes(el));
